export var UserType;
(function (UserType) {
    UserType["StudioModel"] = "StudioModel";
    UserType["Client"] = "Client";
    UserType["System"] = "System";
})(UserType || (UserType = {}));
